(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-page"]) return;
  try {
    
  if(document.getElementById("model-data")){
    //Defines the model
    var model = document.getElementsByClassName("model-selector");
    var modelname = document.querySelector("#model-name");
    var modelnameplural = document.querySelector("#model-name-plural");
    var modelsize = document.querySelector("#model-size");
    var modelbustsize = document.querySelector("#model-bust-size");
    var modelwaistsize = document.querySelector("#model-waist-size");
    var modelhipsize = document.querySelector("#model-hip-size");
    //Checks if `addEventListener` can be used and adds the click eventlListener
    for (var i = 0; i < model.length; i++){
      model[i].addEventListener('click', function() {
        modelname.innerHTML = this.getAttribute('data-model-name');
        modelnameplural.innerHTML = this.getAttribute('data-model-name')+"'s";
        modelsize.innerHTML = this.getAttribute('data-model-size');
        modelbustsize.innerHTML = this.getAttribute('data-model-bust-size');
        modelwaistsize.innerHTML = this.getAttribute('data-model-waist-size');
        modelhipsize.innerHTML = this.getAttribute('data-model-hip-size');
      }, false);
    }
  }

  } catch(e) { console.error(e); }
})();
})();
